// extracted by mini-css-extract-plugin
module.exports = {"tree":"StyledTree_tree__2nXbY"};